import AccountForm from '../../components/AccountForm/AccountForm';
import './Login.sass';
export default function Login() {
    return (
        <main id="login">
            <AccountForm page="login" />
        </main>
    );
}
